<template>
    <div class="e_handle_content page_update_supply">
        <div class="topOperation">
            <div class="top-left">
                <ShowNavHead />
            </div>
        </div>
        <div class="main-con">
            <div class="crumbs">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>产品</el-breadcrumb-item>
                    <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/supplierManage?active=first' }">施工队列表</el-breadcrumb-item>
                    <el-breadcrumb-item>施工队详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="e_handle_box" v-loading="formLoading">
                <!-- <p class="r_edit_title">基础信息</p> -->
                <el-tabs v-model="activeTransName" @tab-click="handleClick">
                    <el-tab-pane label="基础信息" name="基础信息">
                        <div class="dtl_box">
                        <div class="dtl_list">
                            <div class="dtl_left_box">施工队编号:</div>
                            <div class="dtl_right_box">{{basicQuery.StrConstrteamCode}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">施工队名称:</div>
                            <div class="dtl_right_box">{{basicQuery.StrConstrteamName}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">认证状态:</div>
                            <div class="dtl_right_box">{{strExamStatus}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">区域:</div>
                            <div class="dtl_right_box">{{basicQuery.StrArea}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">城市公司:</div>
                            <div class="dtl_right_box">{{basicQuery.StrCityCompany}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">城市:</div>
                            <div class="dtl_right_box">{{basicQuery.StrCity}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">公司名称:</div>
                            <div class="dtl_right_box">{{basicQuery.StrRegisCompany}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">公司统一社会信用代码:</div>
                            <div class="dtl_right_box">{{basicQuery.StrUsccode}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">负责人姓名:</div>
                            <div class="dtl_right_box">{{basicQuery.StrresponName}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">负责人身份证号:</div>
                            <div class="dtl_right_box">{{basicQuery.StrresponIdcard}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">负责人电话:</div>
                            <div class="dtl_right_box">{{basicQuery.StrresponTel}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">负责人邮箱:</div>
                            <div class="dtl_right_box">{{basicQuery.Strresponemail}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">法人姓名:</div>
                            <div class="dtl_right_box">{{basicQuery.Strlegalper}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">股东姓名:</div>
                            <div class="dtl_right_box">{{basicQuery.Strshareholder}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">施工队星级:</div>
                            <div class="dtl_right_box">{{basicQuery.StrConstrteamStar}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">服务覆盖城市:</div>
                            <div class="dtl_right_box">{{basicQuery.StrServicecities}}</div>
                        </div>
                         <div class="dtl_list">
                            <div class="dtl_left_box">联系地址:</div>
                            <div class="dtl_right_box">{{basicQuery.StrresponAddr}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">仓库地址:</div>
                            <div class="dtl_right_box">{{basicQuery.StrwarehouseAddr}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">纳入日期:</div>
                            <div class="dtl_right_box">{{basicQuery.DtBringDate}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">服务状态:</div>
                            <div class="dtl_right_box">{{basicQuery.StrSerStatus}}</div>
                        </div>
                        <div class="dtl_list" v-if="basicQuery.StrSerStatus == '退出'">
                            <div class="dtl_left_box">退出时间:</div>
                            <div class="dtl_right_box">{{basicQuery.DtexitDate}}</div>
                        </div>
                    </div>
                    </el-tab-pane>
                    <el-tab-pane label="人员信息" name="人员信息">
                        <div class="r_act_box">
                            <div class="r_act_left">
                                <div class="r_act_item">
                                <el-button size="small" type="success" @click="addMemberHandle">新增队员</el-button>
                                </div>
                            </div>
                        </div>
                        <el-table ref="clueTable" class="re_table" v-loading="tableLoading" :highlight-current-row="true" :data="tableData" style="width:100%">
                            <template v-for="(item,index) in tableTitle">
                                <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('身份证号码')>-1||item.StrColumName.indexOf('公司名称')>-1||item.StrColumName.indexOf('证编号')>-1||item.StrColumName.indexOf('意外险保单号')>-1 ? '160px' : item.StrColumName.indexOf('实际施工')>-1||item.StrColumName.indexOf('注销次数')>-1||item.StrColumName.indexOf('意外险保单有效期')>-1||item.StrColumName.indexOf('时间')>-1?'160px':'110px'" align="center"
                                    :fixed="item.StrColumName=='姓名'">
                                    <template slot-scope="{row}">
                                    <p v-if="item.StrColumId=='StrConstrteamName'" class="auth_box">
                                        <!-- <img src="./../../assets/images/auth.png" alt="" v-if="row.StrExamStatus=='已认证'"> -->
                                        <span class="auth_title">{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
                                    </p>
                                    <span v-else>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
                                    </template>
                                </el-table-column>
                            </template>
                            <el-table-column align="center" label="操作" fixed="right" width="150px" class-name="re_act_box">
                                <template slot-scope="{row}">
                                    <el-button type="info" size="mini" plain @click="dtlHandle(row)">详情</el-button>
                                    <el-button type="info" size="mini" plain @click="editHandle(row)">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="block">
                            <el-pagination
                            @current-change="handleCurrentChange01"
                            :current-page.sync="listQuery.currpage"
                            :page-size="listQuery.perpage"
                            @size-change="handleSizeChange01"
                            :page-sizes="[10, 20, 50, 100, 200]"
                            layout="total,sizes,prev,pager,next,jumper"
                            :total="total"
                            ></el-pagination>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="收款人信息" name="收款人信息">
                        <el-table v-loading="payeeLoading" :highlight-current-row="false" class="re_table" :data="payeeData" style="width:100%">
                            <el-table-column align="center" label="收款人姓名" min-width="110px" fit :show-overflow-tooltip="true">
                                <template slot-scope="{row}">
                                    <span>{{row.StrPayeeName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" label="收款人身份证" min-width="110px" fit :show-overflow-tooltip="true">
                                <template slot-scope="{row}">
                                    <span>{{row.StrPayeeIdcard}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" label="收款人银行卡号" min-width="110px" fit :show-overflow-tooltip="true">
                                <template slot-scope="{row}">
                                    <span>{{row.StrPayeeBankNum}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" label="收款人银行" min-width="110px" fit :show-overflow-tooltip="true">
                                <template slot-scope="{row}">
                                    <span>{{row.StrPayeeBankName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" label="收款人电话" min-width="110px" fit :show-overflow-tooltip="true">
                                <template slot-scope="{row}">
                                    <span>{{row.StrPayeeTel}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
                <div class="e_handle_form" v-if="activeTransName=='基础信息'">
                    <div class="f_upload_box">
                        <p class="r_edit_title" v-if="!isNull(fileSupList01)">营业执照</p>
                        <div class="dtl_list" v-if="!isNull(lifespanVal)">
                            <div class="dtl_left_box02">营业执照有效期:</div>
                            <div class="dtl_right_box">{{lifespanVal}}</div>
                        </div>
                        <div class="f_upload_list" v-if="!isNull(fileSupList01)">
                            <!-- <div class="f_upload_left">营业执照:</div> -->
                            <div class="demo-image__preview" v-for="(item,index) in fileSupList01" :key="index">
                                <el-image v-if="item.type == 'img'"
                                    style="width: 100px; height: 100px;margin-right:10px"
                                    :src="tablePath+item.url" 
                                    :preview-src-list="[tablePath+item.url]">
                                </el-image>
                                <p v-else class="dtl_file_txt" :title="item.name">{{item.name}}</p>
                                <el-button type="text" size="small" @click="handleDownload(item)">下载</el-button>
                            </div>
                        </div>
                        <p class="r_edit_title" v-if="!isNull(fileSupList02)">法人委托授权书</p>
                        <div class="f_upload_list" v-if="!isNull(fileSupList02)">
                            <!-- <div class="f_upload_left">法人委托授权书:</div> -->
                            <div class="demo-image__preview" v-for="(item,index) in fileSupList02" :key="index">
                                <el-image v-if="item.type == 'img'"
                                    style="width: 100px; height: 100px"
                                    :src="tablePath+item.url" 
                                    :preview-src-list="[tablePath+item.url]">
                                </el-image>
                                <p v-else class="dtl_file_txt" :title="item.name">{{item.name}}</p>
                                <el-button type="text" size="small" @click="handleDownload(item)">下载</el-button>
                            </div>
                        </div>
                        <p class="r_edit_title" v-if="!isNull(fileSupList03)">工程车照片</p>
                        <div class="dtl_list" v-if="plateNumber">
                            <div class="dtl_left_box01">车牌号:</div>
                            <div class="dtl_right_box">{{plateNumber}}</div>
                        </div>
                        <div class="f_upload_list" v-if="!isNull(fileSupList03)">
                            <!-- <div class="f_upload_left">工程车照片:</div> -->
                            <div class="demo-image__preview" v-for="(item,index) in fileSupList03" :key="index">
                                <el-image v-if="item.type == 'img'"
                                    style="width: 100px; height: 100px"
                                    :src="tablePath+item.url" 
                                    :preview-src-list="[tablePath+item.url]">
                                </el-image>
                                <p v-else class="dtl_file_txt" :title="item.name">{{item.name}}</p>
                                <el-button type="text" size="small" @click="handleDownload(item)">下载</el-button>
                            </div>
                        </div>
                        <p class="r_edit_title" v-if="!isNull(fileSupList04)">仓库照片</p>
                        <div class="f_upload_list" v-if="!isNull(fileSupList04)">
                            <!-- <div class="f_upload_left">仓库照片:</div> -->
                            <div class="demo-image__preview" v-for="(item,index) in fileSupList04" :key="index">
                                <el-image v-if="item.type == 'img'"
                                    style="width: 100px; height: 100px"
                                    :src="tablePath+item.url" 
                                    :preview-src-list="[tablePath+item.url]">
                                </el-image>
                                <p v-else class="dtl_file_txt" :title="item.name">{{item.name}}</p>
                                <el-button type="text" size="small" @click="handleDownload(item)">下载</el-button>
                            </div>
                        </div>
                        <p class="r_edit_title" v-if="!isNull(fileSupList05)">其他资质</p>
                        <div class="f_upload_list" v-if="!isNull(fileSupList05)">
                            <!-- <div class="f_upload_left">其他资质:</div> -->
                            <div class="demo-image__preview" v-for="(item,index) in fileSupList05" :key="index">
                                <el-image v-if="item.type == 'img'"
                                    style="width: 100px; height: 100px"
                                    :src="tablePath+item.url" 
                                    :preview-src-list="[tablePath+item.url]">
                                </el-image>
                                <p v-else class="dtl_file_txt" :title="item.name">{{item.name}}</p>
                                <el-button type="text" size="small" @click="handleDownload(item)">下载</el-button>
                            </div>
                        </div>
                        <p class="r_edit_title" v-if="!isNull(fileSupList06)">图片上传渠道</p>
                        <div class="f_upload_list" v-if="!isNull(fileSupList06)">
                            <!-- <div class="f_upload_left">图片上传渠道:</div> -->
                            <div class="f_upload_right">
                                <div class="demo-image__preview" v-for="(item,index) in fileSupList06" :key="index">
                                <el-image v-if="item.type == 'img'"
                                    style="width: 100px; height: 100px"
                                    :src="tablePath+item.url" 
                                    :preview-src-list="[tablePath+item.url]">
                                </el-image>
                                <p v-else class="dtl_file_txt" :title="item.name">{{item.name}}</p>
                                <el-button type="text" size="small" @click="handleDownload(item)">下载</el-button>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="e_btns_box">
            <div class="e_btns_content">
                <el-button @click="backHandle">返回</el-button>
                <el-button v-if="isStrExamStatus" type="primary" :loading="btnLoading" @click="identifyHandle">认证</el-button>
            </div>
        </div>
        <!-- 图片预览 -->
        <el-dialog :visible.sync="predialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <!-- 修改认证状态弹框 -->
        <el-dialog title="设置认证状态" :visible.sync="identifyVisible" width="600px" class="res_dialog">
            <el-form :model="identifyQuery" :rules="identifyRules" ref="dtreachForm" class="re_dialog_form" label-width="130px">
                <el-form-item label="认证状态:" prop="StrExamStatus">
                    <el-select v-model="identifyQuery.StrExamStatus" placeholder="" size="small">
                        <el-option label="已认证" value="已认证"></el-option>
                        <el-option label="认证失败" value="认证失败"></el-option>
                        <el-option label="未认证" value="未认证"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注:" prop="strRemark">
                    <el-input v-model="identifyQuery.strRemark" type="textarea" size="small" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button
                    @click="identifyVisible = false"
                    size="small"
                    >取消</el-button>
                <el-button
                    type="primary" class="com_dialog_btn"
                    @click="saveIdentifyHandle"
                    size="small"
                    >确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import xz from "./../../common";
import moment from 'moment'
export default {
    data() {
        return {
            // 收款人列表
            payeeLoading:false,
            isStrExamStatus:false,//是否认证
            payeeData:[],
            payeeQuery:{
                GdteamId:'',//施工队id    
                StrConstrteamCode:''//施工队编号 
            },
            tableData:[],//人员列表
            total:0,
            tableLoading:false,
            strExamStatus:'',
            tableTitle:[],//表头
            listQuery:{
                strConstrteamName:'',// 施工队名称
                strPerName:'',//  姓名
                strDutie:'',// 职务(人员分类)
                strArea:'',// 区域
                strCityCompany:'',// 城市公司
                strConstrteamCode:'',
                currpage:1,
                perpage:10
            },
            // 表头参数
            titleQuery:{
                strTableId:'JB_busi_ConstrPerson', //JB_busi_UtilityBill (费用单) JB_busi_ConstrPerson（施工人员）JB_busi_ConstrTeam（施工队）JB_report_Receivables  应收款报表
                strIsFixed:''
            },
            activeTransName:'基础信息',
            pageTitle:'施工队详情',
            tablePath: this.$store.state.EMP.docPath,
            predialogVisible:false,
            dialogImageUrl:'',//预览图片
            btnLoading:false,
            formLoading:false,
            // 默认头像
            defaultPic: require(("./../../assets/images/psn.png")),
            // 基础信息参数
            basicQuery:{
                GdteamId:'',
                StrConstrteamCode:'', //施工队编号
                StrConstrteamName:'', //施工队名称
                StrArea:'', //区域
                StrCityCompany:'', //城市公司
                StrConstrteamStar:'', //施工队星级
                Strmaterialpackage:'', //协议包含物料套餐
                StrresponName:'', //负责人姓名
                StrresponTel:'', //负责人电话
                Strresponemail:'', //负责人邮箱
                StrresponAddr:'', //联系地址
                StrwarehouseAddr:'', //仓库地址
                StrresponIdcard:'', //负责人身份证号
                StrRegisCompany:'', //公司名称
                StrRegisShortCompany:'', //公司简称
                StrUsccode:'', //公司统一社会信用代码
                Strlegalper:'', //法人姓名
                Strshareholder:'', //股东姓名
                StrServicecities:'', //服务覆盖城市
                StrDockplatformser:'', //对接平台服务商
                StrSerStatus:'', //服务状态
                DtBringDate:'', //纳入日期
                DtexitDate:'',// 退出时间
                StrCity:''// 城市
            },
            // 营业执照
            fileSupList01:[],
            // 法人委托授权书
            fileSupList02:[],
            fileSupList03:[],
            fileSupList04:[],
            fileSupList05:[],
            fileSupList06:[],
            activeName:'',
            identifyVisible:false,
            identifyRules: {
                StrExamStatus: [
                    { required: true, message: '请选择认证状态', trigger: 'change' }
                ]
            },
            // 认证参数
            identifyQuery:{
                GdupId:'',//标识
                StrExamStatus:'',//已认证   认证失败  未认证
                strTableId:'JB_busi_ConstrTeam',//JB_busi_ConstrTeam 施工队 JB_busi_ConstrPerson施工队员
                strRemark:'' //备注
            },
            totalPay:0,
            plateNumber:'',//营业执照有效期
            lifespanVal:'' //车牌号
        }
    },
    created() {
        // console.log('yy',this.$route.params)
        // this.processQuery.Jobid = this.$route.params.Jobid
        if(!this.isNull(this.$route.query.id)){
            this.basicQuery.GdteamId = this.$route.query.id
            // 获取详情
            this.getDetailData(this.basicQuery.GdteamId)
        }
    },
    methods:{
        handleClick(tab){
            // console.log('33',tab)
            this.activeTransName = tab.label
            if(tab.label == '人员信息'){
                // 获取人员列表
                this.getTableTitleLists()
            }else if(tab.label == '收款人信息'){
                this.getPayeeList()
            }
        },
        // 退出
        identifyHandle(){
          this.identifyVisible = true
          this.identifyQuery.GdupId = this.basicQuery.GdteamId
          this.identifyQuery.DtexitDate = ''
          this.identifyQuery.strRemark = ''
        },
        // 保存认证
        saveIdentifyHandle(){
          this.$refs['dtreachForm'].validate((valid) => {
            if (valid) {
                xz.saveConstrExamStatus(this.identifyQuery).then(res => {
                    if (res.status == 'ok') {
                        this.$message({ type: 'success', message: '操作成功' })
                        this.getDetailData(this.basicQuery.GdteamId)
                        this.identifyVisible = false
                    }else{
                        this.$message({ type: 'error', message: '操作失败，请稍后再试' })
                    }
                })
            }
          })
        },
        // 判断文件类型,图片预览，文件下载
        updataIf(e) {
            if (e.fileName) {
                let type1 = e.fileName.substring(e.fileName.length-4,e.fileName.length)
                if (type1.indexOf('png')>-1||type1.indexOf('PNG')>-1||type1.indexOf('JPG')>-1||type1.indexOf('JPEG')>-1||type1.indexOf('jpg')>-1||type1.indexOf('jpeg')>-1||type1 == 'webp') {
                    return false
                } else {
                    return true
                }
            } else {
                let type2 = e.name.substring(e.name.length-4,e.name.length)
                if (type2.indexOf('png')>-1||type2.indexOf('PNG')>-1||type2.indexOf('JPG')>-1||type2.indexOf('JPEG')>-1||type2.indexOf('jpg')>-1||type2.indexOf('jpeg')>-1||type2 == 'webp') {
                    return false
                } else {
                    return true
                }
            }
        },
        // 获取详情
        getDetailData(id){
            let that = this
            this.fileSupList01 = []
            this.fileSupList02 = []
            this.fileSupList03 = []
            this.fileSupList04 = []
            this.fileSupList05 = []
            this.fileSupList06 = []
            xz.getConstrTeamDetail({GdteamId:id}).then(res => {
                // console.log('www', res)
                if (res.status == 'ok') {
                    if(res.msg.StrExamStatus == '已认证'){
                        this.isStrExamStatus = false
                    }else{
                        this.isStrExamStatus = true
                    }
                    this.strExamStatus = res.msg.StrExamStatus
                    this.listQuery.strConstrteamCode = res.msg.StrConstrteamCode
                    this.payeeQuery.GdteamId = res.msg.GdteamId
                    this.payeeQuery.StrConstrteamCode = res.msg.StrConstrteamCode
                    this.basicQuery = {
                        GdteamId:res.msg.GdteamId,
                        StrConstrteamCode:res.msg.StrConstrteamCode, //施工队编号
                        StrConstrteamName:res.msg.StrConstrteamName, //施工队名称
                        StrArea:res.msg.StrArea, //区域
                        StrPerStatus:res.msg.StrPerStatus, //城市公司
                        StrCityCompany:res.msg.StrCityCompany, //施工队星级
                        Strmaterialpackage:res.msg.Strmaterialpackage, //协议包含物料套餐
                        StrresponName:res.msg.StrresponName, //负责人姓名
                        StrresponTel:res.msg.StrresponTel, //负责人电话
                        Strresponemail:res.msg.Strresponemail, //负责人邮箱
                        StrresponAddr:res.msg.StrresponAddr, //联系地址
                        StrwarehouseAddr:res.msg.StrwarehouseAddr, //仓库地址
                        StrresponIdcard:res.msg.StrresponIdcard, //负责人身份证号
                        StrRegisCompany:res.msg.StrRegisCompany, //公司名称
                        StrRegisShortCompany:res.msg.StrRegisShortCompany, //公司简称
                        StrUsccode:res.msg.StrUsccode, //公司统一社会信用代码
                        Strlegalper:res.msg.Strlegalper, //法人姓名
                        Strshareholder:res.msg.Strshareholder, //股东姓名
                        StrServicecities:res.msg.StrServicecities, //服务覆盖城市
                        StrDockplatformser:res.msg.StrDockplatformser, //对接平台服务商
                        StrSerStatus:res.msg.StrSerStatus, //服务状态
                        DtBringDate:res.msg.DtBringDate, //纳入日期
                        DtexitDate:res.msg.DtexitDate,// 退出时间
                        StrCity:res.msg.StrCity// 城市
                    }
                    if(!this.isNull(res.msg.StrConstrteamName)){
                        let resTxt = res.msg.StrConstrteamName.split(res.msg.StrConstrteamCode)
                        this.basicQuery.StrRegisShortCompany = resTxt[1]
                    }
                    if(!this.isNull(res.msgfile1)){
                        if(!this.isNull(res.msgfile1[0].DtStartDate)){
                            this.lifespanVal = res.msgfile1[0].DtStartDate+' 至 '+res.msgfile1[0].DtEndDate
                        }
                        for (let i = 0; i < res.msgfile1.length; i++) {
                            let element1 = res.msgfile1[i];
                            let type1 = element1.StrFile.substring(element1.StrFile.length-4,element1.StrFile.length)
                            this.fileSupList01.push({
                                url:element1.StrFileUrl,
                                name:element1.StrFile,
                                type: (type1.indexOf('png')>-1||type1.indexOf('PNG')>-1||type1.indexOf('JPG')>-1||type1.indexOf('JPEG')>-1||type1.indexOf('jpg')>-1||type1.indexOf('jpeg')>-1||type1 == 'webp')?'img':'file'
                            })
                        }
                    }
                    if(!this.isNull(res.msgfile2)){
                        for (let j = 0; j < res.msgfile2.length; j++) {
                            let element2 = res.msgfile2[j];
                            let type2 = element2.StrFile.substring(element2.StrFile.length-4,element2.StrFile.length)
                            this.fileSupList02.push({
                                url:element2.StrFileUrl,
                                name:element2.StrFile,
                                type: (type2.indexOf('png')>-1||type2.indexOf('PNG')>-1||type2.indexOf('JPG')>-1||type2.indexOf('JPEG')>-1||type2.indexOf('jpg')>-1||type2.indexOf('jpeg')>-1||type2 == 'webp')?'img':'file'
                            })
                        }
                    }
                    if(!this.isNull(res.msgfile3)){
                        this.plateNumber = res.msgfile3[0].StrRemark
                        for (let k = 0; k < res.msgfile3.length; k++) {
                            let element3 = res.msgfile3[k];
                            let type3 = element3.StrFile.substring(element3.StrFile.length-4,element3.StrFile.length)
                            this.fileSupList03.push({
                                url:element3.StrFileUrl,
                                name:element3.StrFile,
                                type: (type3.indexOf('png')>-1||type3.indexOf('PNG')>-1||type3.indexOf('JPG')>-1||type3.indexOf('JPEG')>-1||type3.indexOf('jpg')>-1||type3.indexOf('jpeg')>-1||type3 == 'webp')?'img':'file'
                            })
                        }
                    }
                    if(!this.isNull(res.msgfile4)){
                        for (let l = 0; l < res.msgfile4.length; l++) {
                            let element4 = res.msgfile4[l];
                            let type4 = element4.StrFile.substring(element4.StrFile.length-4,element4.StrFile.length)
                            this.fileSupList04.push({
                                url:element4.StrFileUrl,
                                name:element4.StrFile,
                                type: (type4.indexOf('png')>-1||type4.indexOf('PNG')>-1||type4.indexOf('JPG')>-1||type4.indexOf('JPEG')>-1||type4.indexOf('jpg')>-1||type4.indexOf('jpeg')>-1||type4 == 'webp')?'img':'file'
                            })
                        }
                    }
                    if(!this.isNull(res.msgfile5)){
                        for (let m = 0; m < res.msgfile5.length; m++) {
                            let element5 = res.msgfile5[m];
                            let type5 = element5.StrFile.substring(element5.StrFile.length-4,element5.StrFile.length)
                            this.fileSupList05.push({
                                url:element5.StrFileUrl,
                                name:element5.StrFile,
                                type: (type5.indexOf('png')>-1||type5.indexOf('PNG')>-1||type5.indexOf('JPG')>-1||type5.indexOf('JPEG')>-1||type5.indexOf('jpg')>-1||type5.indexOf('jpeg')>-1||type5 == 'webp')?'img':'file'
                            })
                        }
                    }
                    if(!this.isNull(res.msgfile6)){
                        for (let n = 0; n < res.msgfile6.length; n++) {
                            let element6 = res.msgfile6[n];
                            let type6 = element6.StrFile.substring(element6.StrFile.length-4,element6.StrFile.length)
                            this.fileSupList06.push({
                                url:element6.StrFileUrl,
                                name:element6.StrFile,
                                type: (type6.indexOf('png')>-1||type6.indexOf('PNG')>-1||type6.indexOf('JPG')>-1||type6.indexOf('JPEG')>-1||type6.indexOf('jpg')>-1||type6.indexOf('jpeg')>-1||type6 == 'webp')?'img':'file'
                            })
                        }
                    }
                }else{
                    this.$message({ type: 'error', message: res.msg })
                }
            })
        },
        // 跳转人员详情
        dtlHandle(row){
          let routeUrl = this.$router.resolve(
            { path: '/teamMemberDetail',query:{
              id: row.GdteamperId
            }
          });
          window.open(routeUrl.href, '_blank');
        },
        // 跳转人员编辑
        editHandle(row){
          // console.log('row',row)
          let routeUrl = this.$router.resolve(
            { path: '/updateTeamMember',query:{
              id: row.GdteamperId
            }
          });
          window.open(routeUrl.href, '_blank');
        },
        // 新增队员
        addMemberHandle(){
            let routeUrl = this.$router.resolve(
                { path: '/updateTeamMember',query:{
              GdteamId: this.basicQuery.GdteamId
            }
            });
            window.open(routeUrl.href, '_blank');
        },
        // 获取表头
        getTableTitleLists(){
          xz.getEcustColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then(res => {
            // console.log('33',res)
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getMemberList()
            }else{
              this.tableTitle = []
            }
          })
        },
        // 获取人员列表
        getMemberList(){
            this.tableLoading = true
            xz.getConstrTeamPersonLists(this.listQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                  this.tableData = res.msg
                  this.total = res.totalcount
                }else{
                  this.tableData = []
                  this.total = 0
                }
              this.tableLoading = false
            })
        },
        // 获取收款人列表
        getPayeeList(){
            this.payeeLoading = true
            xz.getConstrTeamPayeelist(this.payeeQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                  this.payeeData = res.msg
                //   this.totalPay = res.totalcount
                }else{
                  this.payeeData = []
                //   this.totalPay = 0
                }
              this.payeeLoading = false
            })
        },
        //分页
        handleCurrentChange01(val){
            this.listQuery.currpage = Number(val)
            this.getMemberList()
        },
        handleSizeChange01(val) {
            this.listQuery.currpage = 1
            this.listQuery.perpage = Number(val)
            this.getMemberList()
        },
        downloadByBlob(url,name) {
            let image = new Image()
            image.setAttribute('crossOrigin', 'anonymous')
            image.src = this.tablePath + url
            image.onload = () => {
            let canvas = document.createElement('canvas')
            canvas.width = image.width
            canvas.height = image.height
            let ctx = canvas.getContext('2d')
            ctx.drawImage(image, 0, 0, image.width, image.height)
            canvas.toBlob((blob) => {
                let url = URL.createObjectURL(blob)
                let aTag = document.createElement('a')
                aTag.href = url
                aTag.click();
                aTag.remove()
                // 用完释放URL对象
                URL.revokeObjectURL(url)
            })
            }
        },
        // 下载附件
        handleDownload(item) {
            // console.log('url',item);
            // let that = this
            // let type = item.url.substring(item.url.length-4,item.url.length)
            // if(type.indexOf('png')>-1||type.indexOf('PNG')>-1||type.indexOf('JPG')>-1||type.indexOf('JPEG')>-1||type.indexOf('jpg')>-1||type.indexOf('jpeg')>-1||type == 'webp'){
            //     console.log('url22');
            //     that.downloadByBlob(item.url,item.name)
            // }else{
                let d = item.url.replace("\"", "").replace("\"", "")
                var path = this.tablePath + d
                const aTag = document.createElement('a')
                aTag.href = path
                aTag.click();
                aTag.remove()
            // }
        },
        // 返回
        backHandle(){
            this.$router.push({
                path: '/supplierManage'
            })
            // this.$router.go(-1) // 后退+刷新
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
        }
    }
}
</script>

<style>
.e_handle_content .el-form--inline .el-form-item__content{
    vertical-align: middle;
}
.e_handle_content .el-form-item__content{
    width: 335px;
}
.e_handle_content .e_half_line01 .el-form-item__content{
    width: 535px;
}
.e_handle_content .f_all_width01 .el-form-item__content{
    width: calc(100% - 135px);
}
.f_all_width .el-form-item__content{
    width: calc(100% - 135px);
}
.e_handle_content .el-form-item{
    margin-bottom: 16px;
    margin-right: 0;
}
.com_upload_btn .el-icon-plus:before{
    font-size: 28px;
    color: #8c939d;
}
/* .page_update_supply .el-upload-list__item .el-icon-close{
    display: block;
} */
.re_table.el-table .cell{
padding: 0 5px;
}
.re_table.el-table .el-table__cell{
padding: 3px 0;
}
.page_update_supply .el-tabs__header{
    padding-left: 15px;
}
</style>
<style scoped>
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  margin-bottom: 15px;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.dtl_file_txt{
    margin-right:10px;
    width:100px;
    white-space:nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.demo-image__preview{
    display: flex;
    align-items: center;
    margin-right: 30px;
    margin-bottom: 10px;
}
.dtl_list{
    display: flex;
    /* flex-wrap: wrap; */
    width: 50%;
    margin-bottom: 12px;
    /* align-items: center; */
}
.dtl_right_box{
    color:#000;
    flex: 1;
}
.dtl_left_box{
    width: 145px;
    text-align: right;
    color:#999;
    margin-right: 4px;
}
.dtl_left_box01{
    width: 60px;
    text-align: right;
    color:#999;
    margin-right: 4px;
}
.dtl_left_box02{
    width: 110px;
    text-align: right;
    color:#999;
    margin-right: 4px;
}
.dtl_box{
    display: flex;
    flex-wrap: wrap;
    padding: 10px 20px;
    box-sizing: border-box;
}
.c_form_box{
    display: flex;
    box-sizing: border-box;
}
.page_update_supply{
    position: relative;
}
.page_update_supply .main-con{
    padding: 0px 15px 80px;
}
.f_date_box{
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.f_date_box .f_left{
    text-align: right;
    width: 110px;
    font-size: 14px;
    margin-right: 4px;
    color: #606266;
}
.f_date_box .f_left.f_left01{
    width: 55px;
}
.f_date_box .f_left .note_icon{
    color:#F56C6C;
}
.com_upload_btn{
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
}
.r_edit_title .note_icon{
    color:#F56C6C;
    margin-left: 4px;
}
.f_upload_box{
    width: 100%;
}
.r_edit_title{
    width: 100%;
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 10px;
    font-weight: bold;
    padding-left: 20px;
    border-bottom: 1px dashed #ddd;
    box-sizing: border-box;
    color: #333;
}
.u_txt{
    color:#999;
    font-weight: bold;
    font-size: 13px;
    margin-bottom: 10px;
}
.f_upload_list{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 20px;
}
.f_upload_left{
    width: 130px;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    /* line-height: 40px; */
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.face_line_box{
  display:flex;
  flex-wrap: wrap;
  font-size: 14px;
  margin-left: 10px;
}
.face_line_box .txts01{
  margin-right: 3px;
}
.face_line_box .txts02{
  margin-left: 3px;
}
.r_flex{
    display: flex;
    align-items: center;
}
.e_bottom_box{
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.e_bottom_box p{
    margin-right: 10px;
}
.e_handle_form{
    width: 100%;
    margin: 0 auto;
    flex-wrap: wrap;
}
.e_half_line{
    width: 549px;
}
.e_half_line01{
    width: 652px;
}
.e_handle_content .el-input,.e_handle_content .el-cascader,.e_handle_content .el-select{
    width: 330px;
}
.e_form_box{
    margin-top: 10px;
}
.e_btns_content{
    width: 160px;
    margin-left: calc(50% - 160px);
}
.e_btns_box{
    width: 100%;
    display: flex;
    /* justify-content: center; */
    position: fixed;
    bottom: 0;
    background: #fff;
    z-index: 100;
    box-sizing: border-box;
    padding: 10px 0;
}
.f_all_width{
  width: 100%;
  align-items: center;
}
.e_line01{
    display: flex;
    align-items: center;
}
.e_handle_box .txt01{
    font-size: 13px;
    color:#19bd92;
    cursor: pointer;
    margin-left: 5px;
}
.e_handle_form{
    display: flex;
    /* text-align: center; */
}
.e_handle_box{
    width: 100%;
    padding: 10px 0;
    background-color: #fff;
    box-sizing: border-box;
}
.e_handle_box .el-form-item__label{
    padding: 0 5px 0 0;
}
.e_title{
    width: 100%;
    text-align: center;
    line-height: 25px;
    font-size: 16px;
    color: #333333;
}
</style>